export default "__VITE_ASSET__ICryczoC__"